import { render, staticRenderFns } from "./DiseaseReportSection.vue?vue&type=template&id=5292d061&scoped=true"
import script from "./DiseaseReportSection.vue?vue&type=script&lang=js"
export * from "./DiseaseReportSection.vue?vue&type=script&lang=js"
import style0 from "./list.css?vue&type=style&index=0&id=5292d061&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5292d061",
  null
  
)

export default component.exports